import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const HostingAwardPrompt = ({ campaign, dismissible = false, children = null }) => {
  const [dismissed, setDismissed] = useState(false);
  const [expired, setExpired] = useState(false);
  const storageKey = campaign ? `${campaign.id}-dismissed` : null;

  useEffect(() => {
    if (!campaign) return;

    const checkExpiry = () => setExpired(Date.now() >= Date.parse(campaign.ends_at));
    checkExpiry();
    const interval = window.setInterval(checkExpiry, 1000);
    if (dismissible) {
      try {
        setDismissed(window.localStorage.getItem(storageKey) === '1');
      } catch (_error) {
        // Storage may be unavailable; closing still works for this page.
      }
    }
    return () => window.clearInterval(interval);
  }, [campaign, dismissible, storageKey]);

  if (!campaign || expired) return children;
  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      window.localStorage.setItem(storageKey, '1');
    } catch (_error) {
      // Keep the in-memory dismissal when browser storage is blocked.
    }
  };

  return (
    <aside className={dismissible ? 'd-flex align-items-start border-bottom pb-3 mb-4' : 'login-review-prompt'} aria-label="Webhoster des Jahres">
      <div className={dismissible ? 'flex-grow-1' : undefined}>
        <strong>Gibst Du uns Deine Stimme?</strong>
        <p className="mb-1">Unterstütze lima-city bei der Wahl zum Webhoster des Jahres {campaign.year}.</p>
        <a href={campaign.url} target="_blank" rel="noopener noreferrer">Jetzt abstimmen →</a>
        <span className="text-muted"> · bis {campaign.deadline}</span>
      </div>
      {dismissible && (
        <button type="button" className="btn btn-link text-muted ml-2 p-2" onClick={dismiss} aria-label="Abstimmungshinweis für diese Kampagne ausblenden">×</button>
      )}
    </aside>
  );
};

HostingAwardPrompt.propTypes = {
  campaign: PropTypes.shape({
    id: PropTypes.string.isRequired,
    year: PropTypes.number.isRequired,
    deadline: PropTypes.string.isRequired,
    ends_at: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }),
  dismissible: PropTypes.bool,
  children: PropTypes.node
};

export default HostingAwardPrompt;
